/**
 * Get the appropriate API URL based on the current environment
 */
export function getApiUrl(): string {
  // Check if we're in production based on hostname
  const hostname = window.location.hostname
  
  if (hostname.includes('4dgs.moonshine-studio.net') || 
      hostname.includes('4dgs.pages.dev') ||
      hostname.includes('.pages.dev')) {
    return 'https://4dgs-api.moonshine-studio.net'
  }
  
  // Use environment variable or default to localhost
  return import.meta.env.VITE_API_URL ?? 'http://localhost:8787'
}

/**
 * Build a full API endpoint URL
 */
export function buildApiUrl(path: string): string {
  const baseUrl = getApiUrl()
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${baseUrl}${normalizedPath}`
}